//#region Imports
import {
    createFeature,
    createReducer,
    on
} from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import {
    PaymentList,
    PaymentsAdapter,
    PaymentsEntityState,
} from './../../interfaces';
import * as PaymentActions from './payments.actions';

//#region Entity consts

export const PaymentsFeatureAdapter: PaymentsAdapter = createEntityAdapter({
    selectId: (e) => e.id,
});

const initialState: PaymentsEntityState = PaymentsFeatureAdapter.getInitialState({
    loaded: false,
    nextPayment: {
        id: '',
        date: '',
        paymentAmount: 0,
        bankAccount: {
            bankName: '',
            id: '',
            last4Number: ''
        }
    }
});

const LoadPaymentsAction: any =
    (state: PaymentsEntityState) => ({ ...state, loaded: false });

const ResetPaymentsAction: any =
    (state: PaymentsEntityState) => PaymentsFeatureAdapter.removeAll(state);

const SetPaymentsAction: any =
    (state: PaymentsEntityState, { list, next }: any) => PaymentsFeatureAdapter.setAll(list.list, { ...state, loaded: true, nextPayment: { ...next } });

export const PaymentsFeatureName = 'Payments';

//#region Feature

export const PaymentsFeature = createFeature({
    name: PaymentsFeatureName,
    reducer: createReducer(
        initialState,
        on(PaymentActions.LoadPaymentsAction, LoadPaymentsAction),
        on(PaymentActions.ResetPaymentsAction, ResetPaymentsAction),
        on(PaymentActions.SetPaymentsAction, SetPaymentsAction),
    )
});